import {
  buildExportCatalog,
  enrichExportNode,
  indexDatabaseCsvExports,
  type EnrichedExportNode,
  type ExportCatalog,
  type NotionExportNode,
} from '@couplespace/core/notion-export';

import { type ExportFolderScan } from './read-export-folder.js';

function enrichTree(
  nodes: NotionExportNode[],
  databaseCsvByNotionId: ReturnType<typeof indexDatabaseCsvExports>,
): EnrichedExportNode[] {
  return nodes.map((node) =>
    enrichExportNode(node, databaseCsvByNotionId, enrichTree(node.children, databaseCsvByNotionId)),
  );
}

export function buildImportCatalog(scan: ExportFolderScan, roots: NotionExportNode[]): ExportCatalog {
  const databaseCsvByNotionId = indexDatabaseCsvExports(scan.paths);
  const enriched = enrichTree(roots, databaseCsvByNotionId);
  return buildExportCatalog(enriched, databaseCsvByNotionId);
}
